import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {Location} from "@angular/common";
import {Subscription} from "rxjs";
import {CheckoutSteps} from "../../../../common";
import {
  AppService,
  Discount,
  getStepRoute,
  Host,
  IMenuSection,
  Menu,
  MenuGroup,
  BenefitSelection,
  Cart
} from "../../../../common";


@Component({
  standalone: false,
  template: `
    <checkout-header [host]="host" (back)="back()" (next)="next()"
                     [cart]="cart"
                     [step]="getNextStep()"
                     [canProceed]="canProceed()"></checkout-header>
    <main class="container">
      <h5 class="mt-3">{{selection.title}}</h5>
      <p i18n>Select your free item</p>
      <div *ngFor="let section of itemList">
        <h5 *ngIf="section.title">{{section.title}}</h5>
        <div *ngFor="let item of section.items">
          <item-card [item]="item" (clickButton)="onSelect(item, $event)"
                     buttonText="Select this" i18n-buttonText>
            <!--
            <p class="text-center mt-3 mb-0">
              <button type="button" class="btn btn-primary order-button" (click)="onSelect(item)">
                <i class="fas fa-hand-point-up"></i>&nbsp;<span i18n>Select this</span>
              </button>
            </p>
            -->
          </item-card>
        </div>
      </div>
    </main>
  `
})
export class SelectBenefitPage implements OnInit, OnDestroy {

  host: Host;
  menu: Menu;
  cart: Cart;
  group: MenuGroup;
  itemList: Array<IMenuSection>;
  nextStep: CheckoutSteps;
  selection: BenefitSelection;
  discount: Discount;
  private subscriptions: Array<Subscription> = new Array<Subscription>();

  constructor(
    private router: Router,
    private location: Location,
    private appService: AppService
  ) {
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.appService.load().subscribe(({host, menu, cart}) => {
        this.host = host;
        this.menu = menu;
        this.cart = cart;
        if (!this.setSelection()) {
          // go back to checkout
          this.router.navigate(['/', 'checkout']);
        }
      })
    )
  }

  back() {
    this.location.back()
  }

  getNextStep() {
    return this.cart.getNextCheckoutStep();
  }

  canProceed() {
    if (!this.selection) {
      return true;
    }
    return this.selection.variant != null;
  }

  setSelection(): boolean {
    this.selection = this.cart.nextOpenSelection();
    if (this.selection) {
      if (this.selection.group) {
        this.group = this.selection.group;
        this.itemList = this.group.item_list();
      } else {
        this.group = null;
        this.itemList = [
          {
            'title': '',
            items: [this.selection.item]
          }
        ];
      }
      return true;
    } else {
      this.group = null;
      return false;
    }
  }

  onSelect(item, variant) {
    if (item.hasVariants()) {
      this.selection.item = item;
      this.selection.variant = variant;
      this.next();
    } else {
      // move forward
      this.selection.item = item;
      this.selection.variant = 0;
      this.next();
    }
  }

  next() {
    if (this.canProceed()) {
      this.selection = this.cart.setBenefitSelection(this.selection.id, this.selection.item, this.selection.variant);
      if (this.selection) {
        // we have another free item to choose,
        // refresh view
        this.setSelection();
      } else {
        this.router.navigate(getStepRoute(this.cart.getNextCheckoutStep()))
      }
    }
  }

  ngOnDestroy(): void {
    let sub = null;
    while (sub = this.subscriptions.pop()) {
      sub.unsubscribe();
    }
  }

}
